(function() {
'use strict';

angular
    .module('TR')
    .directive('occupancyUnified', Occupancy);

function Occupancy($timeout, $route, $document, arrayUtil, occupancyService) {
    const minAdults = 2;

    return {
        restrict: 'E',
        replace: true,
        scope: {
            maxRooms: '@',
            maxAge: '@',
            maxAdultAge: '@',
            occupancy: '=',
            multiroomDisabled: '=',
            hideGroupBookingLink: '@'
        },
        templateUrl: 'partials/home/directivetemplate?type=OccupancyUnified',
        link: _linker
    };

    function _linker(scope, el) {
        const wrapper = $('#occupancy-selectors', el);
        const inp = $('.input-occupancy', el);
        let timer;

        function initPosition() {
            wrapper.position({
                my: 'left top',
                of: inp,
                at: 'left bottom',
                collision: 'fit'
            });
        }
        initPosition();
        function initPositionTimeout() {
            $timeout.cancel(timer);
            timer = $timeout(initPosition, 50);
        }

        scope.getAdultsLimit = memoizePerArea(function(area, firstRoom) {
            const limits = TRPCONFIG.Domain.OccupancyLimits[area];
            const maxValue = (firstRoom && limits) ? limits.maxAdults : 6;
            return arrayUtil.createRange(maxValue);
        });

        scope.getChildrenLimit = memoizePerArea(function(area, firstRoom) {
            const limits = TRPCONFIG.Domain.OccupancyLimits[area];
            const maxValue = (firstRoom && limits) ? limits.maxChildren : 5;
            return arrayUtil.createRange(maxValue, 0);
        });

        scope.getRooms = memoizePerArea(function(area, maxRooms) {
            if (!maxRooms) {
                const limits = TRPCONFIG.Domain.OccupancyLimits[area];
                maxRooms = limits ? limits.maxRooms : 3;
            }
            return arrayUtil.createRange(maxRooms);
        });

        scope.showOccupancyWrapper = showOccupancyWrapper;
        scope.switchWrapper = switchWrapper;

        scope.$watch('occupancy', function(val) {
            if (val) {
                for (let i = 0; i < val.length; i++) {
                     val[i] = sanityCheck(val[i]);
                }
                scope.occupancyString = occupancyService.getOccupancyString(val);
                scope.roomOccupancyString = occupancyService.getRoomOccupancyString(val);
                scope.totalPeopleCounts = occupancyService.getTotalPeopleCounts(val);
            }
        }, true);

        scope.$watch('extraFocusTrackerFocused', function(val) {
            if (val === !!val) {
                if (val) {
                    initPositionTimeout();
                }
                scope.showWrapper = val;
            }
        });

        scope.$watch('showWrapper', function(val) {
            if (val) {
                scope.ages = arrayUtil.createRange(parseInt(scope.maxAge) || TRPCONFIG.Domain.MaximumChildAge, 0);
                scope.adultAges = scope.maxAdultAge ? arrayUtil.createRange(parseInt(scope.maxAdultAge), (parseInt(scope.maxAge) || TRPCONFIG.Domain.MaximumChildAge) + 1) : [];
            }
            if (val && scope.multiroomDisabled && scope.occupancy && scope.occupancy.length > 1) {
                let mergedRoom = { Adults: 0, ChildAges: [] };
                mergedRoom = _.reduce(scope.occupancy, merge, mergedRoom);
                scope.occupancy = [mergedRoom];
            }
            function merge(memo, next) {
                memo.Adults += next.Adults;
                memo.ChildAges = memo.ChildAges.concat(next.ChildAges);
                return memo;
            }
        });

        function sanityCheck(room) {
            room = room || {};
            room.ChildAges = room.ChildAges || [];
            room.Adults = room.Adults || minAdults;
            if (scope.maxAdultAge) {
                room.AdultAges = room.AdultAges || [];
                room.AdultAges.length = room.Adults;
            }
            return room;
        }

        function switchWrapper(value) {
            if (value) {
                initPositionTimeout();
            }
            scope.showWrapper = value;
            if (value === false) {
                $timeout(() => scope.extraFocusTrackerFocused = false);
            }
        }

        function showOccupancyWrapper(e) {
            initPositionTimeout();
            scope.showWrapper = true;

            // Going to attach another click event which should not be fired
            // in the current event bubble
            e.stopPropagation();

            //this function must be declared locally to prevent it being hoisted to far,
            //and then removed from scope
            let _hideOccupancyWrapper = function _hideOccupancyWrapperFn(e) {
                const isChild = el.find(e.target).length > 0;

                if (!isChild) {
                    scope.$apply(function() {
                        scope.showWrapper = false;
                        $document.off('click.occupancy', _hideOccupancyWrapper);
                    });
                }
            };

            inp.on('keydown', function tab(e) {
                if (e.which === 9 || e.which === 27) {
                    scope.$apply(function() {
                        scope.showWrapper = false;
                    });
                }
            });

            $document.on('click.occupancy', _hideOccupancyWrapper);
        }

        function memoizePerArea(func) {
            const memo = _.memoize(
                func,
                (area, input) => `${area}~${input}`
            );
            return function(input) {
                const area = scope.$parent.areaOverride || $route.current.area;
                const result = memo(area, input);
                return result;
            };
        }

        scope.$on('$destroy', function() {
            inp.off('keydown');
            $document.off('click.occupancy');
        });
    }
}
})();
